"use client";

import dynamic from "next/dynamic";

export const TradeCoinDialogDynamic = dynamic(
  () => import("@/components/app/trade/trade-header/trade-coin-dialog"),
  {
    ssr: false,
  },
);
